import { httpClient } from "@/services";
import getClonedObject from "@/helper/getClonedObject";

export default {
	state: {
		settings: [],
		services: [],
		zelleAccount: [],
		zelleAccountDefault: [],
	},
	mutations: {
		updateAccountSettings(state, { setting, service, zelleAccount }) {
			state.settings = setting;
			state.services = service;
			state.zelleAccount = zelleAccount;
			state.zelleAccountDefault = getClonedObject(zelleAccount);
		},
		updateDefaultList(state) {
			state.zelleAccount = getClonedObject(state.zelleAccountDefault);
		}
	},
	actions: {
		async getAccountSettings({ commit, dispatch }) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get("/settings/account");
				if (data) {
					commit('updateAccountSettings', data);
				}
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},
		async onAccountSettingsSave({ commit, dispatch }, values) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post("/settings/account", values);
				if (data && data.status) {
					commit('updateAccountSettings', data);
					dispatch("actionPreloader", false);
					return data;
				}
				dispatch('setAlert', { type: "error", message: "Save data error" });

			} catch (e) {
				console.error(e);
			}
		},
		onDefaultList({ commit }) {
			commit('updateDefaultList');
		}
	},
	getters: {
		accountSettings: s => s.settings,
		zelleAccount: s => s.zelleAccount,
		zelleAccountDefault: s => s.zelleAccountDefault,
		accountServices: s => s.services
	},
};
